<template>
  <div>
    <!-- Snackbar -->
    <v-snackbar v-model="snackbar" top :color="color" :timeout="6000">
      <span v-if="snackbar_msg">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-divider class="my-5"></v-divider>

    <v-card flat class="pa-4 mt-4">
      <v-row class="justify-center">
        <v-col cols="12" sm="4" md="4">
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="calender_year"
            :items="Calendar_Year_list"
            item-text="name"
            item-value="id"
            label="Calendar Year"
            outlined
            persistent-hint
            hint="Please Select Calendar Year"
            @change="getPayrollCountGraph"
          />
        </v-col>
      </v-row>

      <br />

      <v-skeleton-loader v-if="loading" type="image" />

      <!-- Chart -->
      <chart
        v-if="!loading && chartOptions"
        class="chart"
        auto-resize
        :options="chartOptions"
      ></chart>

       <v-divider class="my-10"></v-divider>

      <!-- Second Graph -->
      <div v-if="!loading && yearChartOptions">
        <chart class="chart" auto-resize :options="yearChartOptions"></chart>
      </div>

      <v-skeleton-loader v-if="loading" type="image" />

      <!-- 3️⃣ Employee Typewise Salary Expenditure -->
    
      <chart
        v-if="!loading && empTypeChartOptions"
        class="chart"
        :options="empTypeChartOptions"
        auto-resize
      ></chart>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      snackbar: false,
      calender_year: null,
      Calendar_Year_list: [],
      color: "",
      snackbar_msg: "",
      loading: false,
      chartOptions: null,
       yearChartOptions: null,
        empTypeChartOptions: null,
    };
  },

  mounted() {
    this.onload();
  },

  methods: {
    showSnackbar(color, msg) {
      this.color = color;
      this.snackbar_msg = msg;
      this.snackbar = true;
    },

    async onload() {
      this.loading = true;
      try {
        const res = await axios.post("/AdminDashboard/getAySemStdListForDashboard");
        if (res.data.msg === "200") {
          this.Calendar_Year_list = res.data.Calendar_Year_list;
          this.calender_year = this.Calendar_Year_list[0].id || null;
          if (this.calender_year) {
            await this.getPayrollCountGraph();
          }
        } else {
          this.showSnackbar("error", res.data.msg || "Failed to load data");
        }
      } catch (err) {
        console.error(err);
        this.showSnackbar("error", "Server Error");
      } finally {
        this.loading = false;
      }
    },

    async getPayrollCountGraph() {
      if (!this.calender_year) return;
      this.loading = true;

      try {
        const payload = { calender_year: this.calender_year };
        const res = await axios.post("/AdminDashboard/getPayrollCountGraph", payload);

        if (res.data.flag === "YES" && res.data.dataForPayrollGraph.length > 0) {
          const graphData = res.data.dataForPayrollGraph;

          // Prepare chart data
          const months = graphData.map((item) => item.month_name);
          const netSalaries = graphData.map((item) => item.net_salary_lakhs);

          // ECharts options
          this.chartOptions = {
            tooltip: {
              trigger: "axis",
              formatter: (params) => {
                const data = params[0];
                return `${data.name}<br/>Salary: ${data.value} Lakh ₹`;
              },
            },
            xAxis: {
              type: "category",
              data: months,
              axisLabel: { rotate: 30 },
            },
            yAxis: {
              type: "value",
              name: "Salary (Lakhs ₹)",
              nameTextStyle: { fontWeight: "bold" },
            },
            series: [
              {
                data: netSalaries,
                type: "bar",
                barWidth: "50%",
                itemStyle: {
                  borderRadius: [5, 5, 0, 0],
                },
              },
            ],
            title: {
              text: "Monthwise Salary Expenditure (in Lakhs)",
              left: "center",
              top: 10,
              textStyle: {
                fontSize: 16,
                fontWeight: "bold",
              },
            },
            grid: {
              top: 60,
              bottom: 80,
              left: 60,
              right: 40,
            },
          };
        } else {
          this.showSnackbar("info", "No salary data found for this year");
          this.chartOptions = null;
        }
         // 2️⃣ Yearwise Data (last 5 years)
          const yearData = res.data.dataYearwiseSalaryExpenditure || [];
          if (yearData.length > 0) {
            const years = yearData.map((i) => i.calender_year);
            const totals = yearData.map((i) =>
              Number((i.total_net_salary / 100000).toFixed(2))
            );

            this.yearChartOptions = {
              title: {
                text: "Yearwise Salary Expenditure (Last 5 Years)",
                left: "center",
              },
              tooltip: { trigger: "axis" },
              xAxis: { type: "category", data: years },
              yAxis: { type: "value", name: "Salary (Lakhs ₹)" },
              series: [
                {
                  type: "bar",
                  smooth: true,
                  data: totals,
                  symbol: "circle",
                  symbolSize: 10,
                  lineStyle: { width: 3 },
                  areaStyle: {
                    opacity: 0.2,
                  },
                },
              ],
            };
          }
          // --- 3️⃣ Employee Typewise Salary Expenditure ---
        
const empTypeData = res.data.dataEmployeeTypewiseSalaryExpenditure || [];

if (empTypeData.length > 0) {
  // Get unique years and employee types
  const years = [...new Set(empTypeData.map(i => i.calender_year))].sort();
  const employeeTypes = [...new Set(empTypeData.map(i => i.employee_type))];

  // Prepare series for each employee type
  const series = employeeTypes.map((type, index) => {
    const data = years.map(year => {
      const record = empTypeData.find(i => i.employee_type === type && i.calender_year === year);
      return record ? Number((record.total_net_salary / 100000).toFixed(2)) : 0;
    });

    const colors = ["#CDB4DB", "#FFC8DD"]; // light colors
    return {
      name: type,
      type: "bar",
      data: data,
      barWidth: "30%",
      itemStyle: { color: colors[index % colors.length], borderRadius: [6,6,0,0] },
      label: { show: true, position: "top", formatter: "{c} L" }
    };
  });

  this.empTypeChartOptions = {
    title: {
      text: "Employee Typewise Salary Expenditure (5 Last Years)",
      left: "center"
    },
    tooltip: { trigger: "axis", axisPointer: { type: "shadow" } },
    legend: { top: 30, data: employeeTypes },
    xAxis: { type: "category", data: years },
    yAxis: { type: "value", name: "Salary (Lakhs ₹)" },
    series: series,
    grid: { top: 80, bottom: 60, left: 60, right: 40 }
  };
} else {
  this.empTypeChartOptions = null;
}


      } catch (err) {
        console.error(err);
        this.showSnackbar("error", "Error fetching salary graph data");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.chart {
  width: 100%;
  height: 400px;
  max-width: 750px;
  margin: 0 auto;
}
</style>
